import { ButtonProps } from './SyntheticButton';
import { css } from 'react-emotion';

const styles = {
  getBaseStyle: (props: ButtonProps) => {
    const {
      theme,
      color,
      fontColor,
      inverse,
      size,
      disabled,
      minimal
    } = props;

    const componentStyles = theme.components.button;
    const primary = (inverse || minimal) ? fontColor : color;
    const secondary = (inverse || minimal) ? color : fontColor;

    const options = {
      ...props,
      primary,
      secondary
    };

    const defaultStyles = componentStyles.defaults(options);
    const sizeStyles = componentStyles.sizes[size];
    const disabledStyles = disabled ? componentStyles.disabled(options) : {};
    const inverseStyles = inverse ? componentStyles.inverse(options) : {};
    const linkStyled = minimal ? componentStyles.minimal(options) : {};

    return {
      ...defaultStyles,
      ...sizeStyles,
      ...inverseStyles,
      ...linkStyled,
      ...disabledStyles
    };
  },
  getBlockStyle: ({ fullWidth }: ButtonProps) => fullWidth ? css({ width: '100%' }) : {},
  getCircleButtonStyle: ({ theme, shape, size, minimal, disabled }: ButtonProps) => {
    const minimalStyles = minimal && !disabled && theme.components.button.circle.minimal ? { ...theme.components.button.circle.minimal.enabled } : {};
    return shape === 'circle' ? ({
      paddingLeft: 0,
      paddingRight: 0,
      height: theme.components.button.circle[size],
      width: theme.components.button.circle[size],
      ...minimalStyles
    }) : null;
  }
};

export default styles;
